import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Heading,
  Text,
} from "@chakra-ui/react";
import "./style.css";
import { useTranslation } from "react-i18next";

export function FAQs() {
  const { t } = useTranslation();

  return (
    <>
      <Box mt={4} mb={6}>
        <Heading
          fontFamily={"Oswald"}
          fontWeight={500}
          fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
          lineHeight={"110%"}
          color={"gray.800"}
          mb={12}
          mx={8}
        >
          {t("faqs.headingPrefix")}&nbsp;
          <Text as={"span"} color={"blue.500"}>
            {t("faqs.headingEmphasis")}
          </Text>
        </Heading>

        <Box
          width={{ sm: "100%", md: "90%" }}
          margin="auto"
          pt={2}
          pb={"30px"}
          textAlign="left"
        >
          <Accordion allowMultiple>
            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.purchasePass.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.purchasePass.answer")}
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.enrollmentFee.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.enrollmentFee.answer")}
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.passDuration.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.passDuration.answer")}
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.paymentMethods.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.paymentMethods.answer")}
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.trySession.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>

              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.trySession.answer")}
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.personalTraining.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>

              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.personalTraining.answer")}
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem>
              <AccordionButton>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  color="blue.500"
                  fontFamily="Oswald"
                >
                  {t("faqs.items.contact.question")}
                </Box>
                <AccordionIcon />
              </AccordionButton>

              <AccordionPanel pb={4} fontSize={"17px"}>
                {t("faqs.items.contact.answer")}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </>
  );
}
